module.exports = __webpack_public_path__ + "img/activity-tracked.9d47b146.png";